'use es6';

import createAction from 'flux-actions/createAction';
import { getContentAccessControlPanelSaveSuccessNotification, getContentAccessControlPanelSaveFailureNotification } from 'ui-memberships-settings-lib/utils/alerts';
import { createTranslatedDangerNotification, createTranslatedSuccessNotification } from '../utils/alertUtils';
import { getUsageTrackerMeta } from '../utils/usageTracker';
import { RECEIVED_CONTENT, REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT, REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_FAILED, REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_SUCCEEDED, REQUESTED_ARCHIVE_CONTENT, REQUESTED_ARCHIVE_CONTENT_FAILED, REQUESTED_ARCHIVE_CONTENT_SUCCEEDED, REQUESTED_ATTACH_TO_LANGUAGE_MASTER, REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED, REQUESTED_ATTACH_TO_LANGUAGE_MASTER_SUCCEEDED, REQUESTED_CHANGE_AUDIENCE_ACCESS, REQUESTED_CHANGE_AUDIENCE_ACCESS_FAILED, REQUESTED_CHANGE_AUDIENCE_ACCESS_SUCCEEDED, REQUESTED_CHANGE_CONTENT_ACCESS, REQUESTED_CHANGE_CONTENT_ACCESS_FAILED, REQUESTED_CHANGE_CONTENT_ACCESS_SUCCEEDED, REQUESTED_CLONE_CONTENT, REQUESTED_CLONE_CONTENT_FAILED, REQUESTED_CLONE_CONTENT_SUCCEEDED, REQUESTED_CONTENT, REQUESTED_CONTENT_FAILED, REQUESTED_CONVERT_CONTENT, REQUESTED_CONVERT_CONTENT_FAILED, REQUESTED_CONVERT_CONTENT_SUCCEEDED, REQUESTED_CREATE_TRANSLATION_VARIATION, REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED, REQUESTED_CREATE_TRANSLATION_VARIATION_SUCCEEDED, REQUESTED_DELETE_CONTENT, REQUESTED_DELETE_CONTENT_FAILED, REQUESTED_DELETE_CONTENT_SUCCEEDED, REQUESTED_PUBLISH_CONTENT, REQUESTED_PUBLISH_CONTENT_FAILED, REQUESTED_PUBLISH_CONTENT_SUCCEEDED, REQUESTED_UNARCHIVE_CONTENT, REQUESTED_UNARCHIVE_CONTENT_FAILED, REQUESTED_UNARCHIVE_CONTENT_SUCCEEDED, REQUESTED_UNPUBLISH_CONTENT, REQUESTED_UNPUBLISH_CONTENT_FAILED, REQUESTED_UNPUBLISH_CONTENT_SUCCEEDED, REQUESTED_UPDATE_CONTENT, REQUESTED_UPDATE_CONTENT_FAILED, REQUESTED_UPDATE_CONTENT_SUCCEEDED, REQUESTED_REMOVE_FROM_LANGUAGE_GROUP, REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_FAILED, REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_SUCCEEDED } from './ActionTypes';
import { usageTrackerAsBeacon } from '../utils/usageTracker';
const getContentActionsFailedMeta = (action, contentType, response, additionalTranslationOptions) => createTranslatedDangerNotification(contentType, action, response, additionalTranslationOptions);
const getContentActionsSucceededMeta = (action, contentType, options) => createTranslatedSuccessNotification(contentType, action, options);
export const requestContent = createAction(REQUESTED_CONTENT);
export const receiveContent = createAction(RECEIVED_CONTENT, content => ({
  content
}));
export const requestedContentFailed = createAction(REQUESTED_CONTENT_FAILED, error => ({
  error
}));
export const requestUpdateContent = createAction(REQUESTED_UPDATE_CONTENT);
export const requestedUpdateContentFailed = createAction(REQUESTED_UPDATE_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('update', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'rename',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedUpdateContentSucceeded = createAction(REQUESTED_UPDATE_CONTENT_SUCCEEDED, null, contentType => getUsageTrackerMeta('contentActionsInteraction', {
  action: 'rename',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
}));
export const requestArchiveContent = createAction(REQUESTED_ARCHIVE_CONTENT);
export const requestedArchiveContentFailure = createAction(REQUESTED_ARCHIVE_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('archive', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'archive',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedArchiveContentSuccess = createAction(REQUESTED_ARCHIVE_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('archive', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'archive',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestArchiveAndUnpublishContent = createAction(REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT);
export const requestedArchiveAndUnpublishContentFailure = createAction(REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('archiveAndUnpublish', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'archive-and-unpublish',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedArchiveAndUnpublishContentSuccess = createAction(REQUESTED_ARCHIVE_AND_UNPUBLISH_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('archiveAndUnpublish', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'archive-and-unpublish',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestUnarchiveContent = createAction(REQUESTED_UNARCHIVE_CONTENT);
export const requestedUnarchiveContentFailure = createAction(REQUESTED_UNARCHIVE_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('unarchive', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'unarchive',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedUnarchiveContentSuccess = createAction(REQUESTED_UNARCHIVE_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('unarchive', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'unarchive',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestPublishContent = createAction(REQUESTED_PUBLISH_CONTENT);
export const requestedPublishContentFailure = createAction(REQUESTED_PUBLISH_CONTENT_FAILED, error => ({
  error
}), (error, contentType, additionalTranslationOptions) => Object.assign({}, getContentActionsFailedMeta('publish', contentType, error, additionalTranslationOptions), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'publish',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedPublishContentSuccess = createAction(REQUESTED_PUBLISH_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('publish', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'publish',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestUnpublishContent = createAction(REQUESTED_UNPUBLISH_CONTENT);
export const requestedUnpublishContentFailure = createAction(REQUESTED_UNPUBLISH_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('unpublish', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'unpublish',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedUnpublishContentSuccess = createAction(REQUESTED_UNPUBLISH_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('unpublish', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'unpublish',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestCloneContent = createAction(REQUESTED_CLONE_CONTENT);
export const requestedCloneContentFailure = createAction(REQUESTED_CLONE_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('clone', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'clone',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedCloneContentSuccess = createAction(REQUESTED_CLONE_CONTENT_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('clone', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'clone',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestDeleteContent = createAction(REQUESTED_DELETE_CONTENT);
export const requestedDeleteContentFailure = createAction(REQUESTED_DELETE_CONTENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('delete', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'delete',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedDeleteContentSuccess = createAction(REQUESTED_DELETE_CONTENT_SUCCEEDED, null, contentType => {
  usageTrackerAsBeacon.track('contentActionsInteraction', {
    action: 'delete',
    'page-type': contentType,
    screen: 'detail',
    status: 'success'
  });
  return getContentActionsSucceededMeta('delete', contentType);
});
export const requestConvertContent = createAction(REQUESTED_CONVERT_CONTENT);
export const requestedConvertContentFailure = createAction(REQUESTED_CONVERT_CONTENT_FAILED, error => ({
  error
}), (error, contentType, newContentType) => Object.assign({}, getContentActionsFailedMeta(`convert-${newContentType}`, contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'convert-type',
  newContentType,
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedConvertContentSuccess = createAction(REQUESTED_CONVERT_CONTENT_SUCCEEDED, null, (contentType, newContentType) => {
  usageTrackerAsBeacon.track('contentActionsInteraction', {
    action: 'convert-type',
    newContentType,
    'page-type': contentType,
    screen: 'detail',
    status: 'success'
  });
  return getContentActionsSucceededMeta(`convert-${newContentType}`, contentType);
});
export const requestCreateTranslationVariation = createAction(REQUESTED_CREATE_TRANSLATION_VARIATION);
export const requestedCreateTranslationVariationFailure = createAction(REQUESTED_CREATE_TRANSLATION_VARIATION_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta('createTranslationVariation', contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'createTranslationVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedCreateTranslationVariationSuccess = createAction(REQUESTED_CREATE_TRANSLATION_VARIATION_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('createTranslationVariation', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'createTranslationVariation',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestAttachToLanguageMaster = createAction(REQUESTED_ATTACH_TO_LANGUAGE_MASTER);
export const requestedAttachToLanguageMasterFailure = createAction(REQUESTED_ATTACH_TO_LANGUAGE_MASTER_FAILED, error => ({
  error
}), (_, contentType) => getUsageTrackerMeta('contentActionsInteraction', {
  action: 'attachToLanguageMaster',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
}));
export const requestedAttachToLanguageMasterSuccess = createAction(REQUESTED_ATTACH_TO_LANGUAGE_MASTER_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('attachToLanguageMaster', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'attachToLanguageMaster',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestRemoveFromLanguageGroup = createAction(REQUESTED_REMOVE_FROM_LANGUAGE_GROUP);
export const requestedRemoveFromLanguageGroupFailure = createAction(REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta(`removeFromLanguageGroup`, contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'removeFromLanguageGroup',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedRemoveFromLanguageGroupSuccess = createAction(REQUESTED_REMOVE_FROM_LANGUAGE_GROUP_SUCCEEDED, null, contentType => Object.assign({}, getContentActionsSucceededMeta('removeFromLanguageGroup', contentType), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'removeFromLanguageGroup',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestChangeAudienceAccess = createAction(REQUESTED_CHANGE_AUDIENCE_ACCESS);
export const requestedChangeAudienceAccessFailure = createAction(REQUESTED_CHANGE_AUDIENCE_ACCESS_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, getContentActionsFailedMeta(`changeAudienceAccess`, contentType, error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'changeAudienceAccess',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const requestedChangeAudienceAccessSuccess = createAction(REQUESTED_CHANGE_AUDIENCE_ACCESS_SUCCEEDED, null, ({
  audienceAccessType,
  contentType,
  lists,
  numContactsFromLists
}) => Object.assign({}, getContentActionsSucceededMeta(`changeAudienceAccess.${audienceAccessType}`, contentType, {
  count: lists.size,
  numContacts: numContactsFromLists
}), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'changeAudienceAccess',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));

// Memberships shared library content access version, see https://git.hubteam.com/HubSpot/ContentMembership/issues/907
export const requestChangeContentAccess = createAction(REQUESTED_CHANGE_CONTENT_ACCESS);
export const requestedChangeContentAccessFailure = createAction(REQUESTED_CHANGE_CONTENT_ACCESS_FAILED, error => ({
  error
}), ({
  contentCategoryId
}) => ({
  notification: Object.assign({}, getContentAccessControlPanelSaveFailureNotification({
    contentCategoryId,
    contentCount: 1
  }), {
    ['data-test-id']: 'changeContentAccess-error'
  })
}));
export const requestedChangeContentAccessSuccess = createAction(REQUESTED_CHANGE_CONTENT_ACCESS_SUCCEEDED, null, ({
  contentCategoryId,
  publicAccessRuleType
}) => ({
  notification: Object.assign({}, getContentAccessControlPanelSaveSuccessNotification({
    contentCategoryId,
    contentCount: 1,
    publicAccessRuleType
  }), {
    ['data-test-id']: `changeContentAccess-${publicAccessRuleType}-success`
  })
}));